import { render, staticRenderFns } from "./landmarkEnterprise.vue?vue&type=template&id=49a5382f&scoped=true&"
import script from "./landmarkEnterprise.vue?vue&type=script&lang=ts&"
export * from "./landmarkEnterprise.vue?vue&type=script&lang=ts&"
import style0 from "./landmarkEnterprise.vue?vue&type=style&index=0&id=49a5382f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5382f",
  null
  
)

export default component.exports